export const environment = {
  production: true,
  enableTracking: false
};
